import axios from "axios"

async function getVehicleConfigurationApi(workspaceUuid: string, vehicleId: string){
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${workspaceUuid}/configuration-vehicles/${vehicleId}`
    })
}

async function postVehicleConfigurationApi(workspaceUuid: string, vehicleId: string, data: any){
    return axios({
        method: "POST",
        url: `/api/v1/workspaces/${workspaceUuid}/configuration-vehicles/${vehicleId}`,
        data
    })
}

async function patchVehicleConfigurationTariffApi(workspaceUuid: string, configId: string, data: any){
    return axios({
        method: "PATCH",
        url: `/api/v1/workspaces/${workspaceUuid}/configuration-vehicles-tariff/${configId}`,
        data
    })
}

async function patchVehicleConfigurationApi(workspaceUuid: string, vehicleId: string, configId: string, data: any){
    return axios({
        method: "PATCH",
        url: `/api/v1/workspaces/${workspaceUuid}/configuration-vehicles/${vehicleId}/${configId}`,
        data
    })
}

async function patchVehicleConfigurationProposalTariffApi(workspaceUuid: string, configId: string, tariff: any){
    return axios({
        method: "PATCH",
        url: `/api/v1/workspaces/${workspaceUuid}/configuration-vehicle-proposal-tariff/${configId}`,
        data: {
            tariff: tariff
        }
    })
}

async function patchVehicleConfigurationDeactivateApi(workspaceUuid: string, configId: string, tariff: any){
    return axios({
        method: "PATCH",
        url: `/api/v1/workspaces/${workspaceUuid}/configuration-vehicle-deactivate/${configId}`,
        data: {
            tariff: tariff
        }
    })
}

async function patchVehicleConfigurationActivateApi(workspaceUuid: string, configId: string, tariff: any){
    return axios({
        method: "PATCH",
        url: `/api/v1/workspaces/${workspaceUuid}/configuration-vehicle-activate/${configId}`,
        data: {
            tariff: tariff
        }
    })
}


export {
    getVehicleConfigurationApi,
    patchVehicleConfigurationApi,
    postVehicleConfigurationApi,
    patchVehicleConfigurationTariffApi,
    patchVehicleConfigurationProposalTariffApi,
    patchVehicleConfigurationActivateApi,
    patchVehicleConfigurationDeactivateApi
}